<template>
  <Popup
    v-model:show="dialogVisible"
    position="bottom"
    height="100%"
    teleport="body"
  >
    <div class="popup-content">
      <div class="dialog-header">
        <Icon
          v-if="showWooView"
          @click="showWooView = false"
          name="icon-arrow-left-l"
          style="font-size: 20px;"
        />
        Dropshipping
        <img
          @click="dialogVisible = false"
          src="@/assets/images/close-icon.svg"
          alt=""
        >
      </div>
      <div class="dialog-body">
        <div
          v-if="!isGoDropshipping"
          class="top-title"
        >
          Select Style Type
        </div>
        <div
          v-if="!isGoDropshipping"
          class="dialog-content"
        >
          <div
            v-if="!showWooView"
            class="select-type"
          >
            <div
              v-for="(item, index) in options"
              :key="index"
              @click="activeIndex = index"
              :class="{ 'active': activeIndex === index }"
              class="type"
            >
              <img
                :src="item"
                alt=""
              >
            </div>
          </div>
          <div
            v-else
            class="woo-view"
          >
            <img
              :src="options[1]"
              height="48px"
              alt=""
            >
            <div class="title">
              Enter your WooCommerce store address below (for example: www.example.com)
            </div>
            <div
              :class="{ 'active': focus }"
              class="input-wrapper"
            >
              <div class="suffix">
                https://
              </div>
              <input
                @focus="focus = true"
                @blur="focus = false"
                v-model="wooUrl"
                placeholder="Please input your WooCommerce store address."
                type="text"
              >
            </div>
          </div>
        </div>
        <div
          v-else
          class="dialog-content error-page"
        >
          <div class="error-tips">
            We have submitted a sourcing request for you, and we will confirm the shipping price within 1 business day. Please use your PC to view the Sourcing Requests. The specific steps are as follows:
          </div>
          <img
            src="@/assets/dropshipping/entrance.jpg"
            width="200px"
            height="300px"
            alt=""
          >
        </div>
        <div class="dialog-footer">
          <div class="buttons">
            <template v-if="!isGoDropshipping">
              <Button
                @click="onCancel"
                class="cancel"
              >
                Cancel
              </Button>
              <Button
                v-if="!showWooView"
                @click="onConfirm"
                class="confirm"
                type="primary"
              >
                Confirm
              </Button>
              <Button
                v-if="showWooView"
                @click="onGoToLink"
                class="confirm"
                type="primary"
                :disabled="!wooUrl"
              >
                Go to Link
              </Button>
            </template>
            <Button
              v-else
              @click="onDropshippingOK"
              class="confirm"
              type="primary"
            >
              OK
            </Button>
          </div>
        </div>
      </div>
    </div>
  </Popup>
</template>

<script setup>
import { Popup } from '@/components/Popup'
import { useDropshipping } from '@/components/Dropshipping/useDropshipping'
import { Icon } from '@/components/Icon'
import { Button } from '@/components/Button'

const {
  dialogVisible,
  options,
  activeIndex,
  showWooView,
  wooUrl,
  focus,
  isGoDropshipping,
  onCancel,
  onConfirm,
  onGoToLink,
  onDropshippingOK
} = useDropshipping()
</script>

<style lang='less' scoped>
.popup-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  height: 100%;
  .dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    height: 48px;
    border-radius: 8px;
    color: #232323;
    font-size: 14px;
    font-family: mon-700;
    background-color: white;
  }

  .dialog-body {
    position: relative;
    flex: 1;
    background-color: white;
    border-radius: 8px;
    padding: 16px 12px;
    .top-title {
      color: #232323;
      font-size: 14px;
      font-family: mon-700;
      margin-bottom: 24px;
    }
  }

  .dialog-content {
    &.error-page {
    }
    .select-type {
      display: flex;
      flex-direction: column;
      gap: 12px;
      .type {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 64px;
        border-radius: 8px;
        border: 1px solid #EBF1F5;
        cursor: pointer;
        &.active {
          border: 2px solid #232323;
        }

        > img {
          height: 40px;
        }
      }
    }
    .woo-view {
      .title {
        margin-top: 24px;
        color: #232323;
        font-size: 14px;
        font-family: mon-600;
      }
      .input-wrapper {
        display: flex;
        margin-top: 12px;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #EBF1F5;
        &.active {
          border: none;
          outline: 2px solid #232323;
        }
        .suffix {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 54px;
          height: 100%;
          color: #6E717A;
          font-size: 12px;
          font-family: mon-500;
          background-color: #f8f8f8;
          border-right: none;
        }
        input {
          flex: 1;
          line-height: 48px;
          padding: 0 12px;
          outline: none;
          border: none;
          caret-color: #1153D6;
          &::placeholder {
            color: #b2b7c2;
            font-size: 12px;
            font-family: mon-500;
          }
        }
      }
    }
    .error-tips {
      margin-top: 14px;
      margin-bottom: 14px;
      color: #5c5c5c;
      font-size: 12px;
      font-family: mon-500;
      line-height: 18px;
    }
  }
  .dialog-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 72px;
    margin-left: -12px;
    border-top: 1px solid #EBF1F5;
    .buttons {
      margin-top: 12px;
      display: flex;
      gap: 12px;
      padding: 0 12px;

      .cancel, .confirm {
        flex: 1;
        height: 44px;
      }
    }
  }
}
</style>
